export enum FinancialStateType {
    BRAZIL = "BRAZIL",
    EUROPE = "EUROPE"
}
